import { GlobalStyles } from '@mui/material';

// The `as const` is because Typescript is having some trouble with inferring types
//  (see https://stackoverflow.com/a/43124412).

const tableHeaderStyles = {
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '14px',
    fontFamily:
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;",
    // textTransform: 'uppercase' as const,
    textAlign: 'left' as const,
    opacity: 0.9,
    color: 'rgba(0, 0, 0, 0.7)',
};

const tableHeaderStylesInMobile = {
    fontWeight: '700',
    fontSize: '0.8em',
    // textTransform: 'uppercase' as const,
    color: '#444',
};

export const tableComponentOverrides = {
    MUIDataTableHeadCell: {
        styleOverrides: {
            data: {
                ...tableHeaderStyles,
            },
            // Gotta repeat the styles above. For some reason,
            //  when a column is not sortable, the above styles don’t
            //  apply, and we have to set them here.
            root: {
                ...tableHeaderStyles,
            },
            sortAction: {
                alignItems: 'center',
            },
            sortLabelRoot: {
                fontSize: '1.1em',
            },
        },
    },
    MUIDataTableBodyCell: {
        styleOverrides: {
            root: {
                fontSize: '1em',
            },
            stackedHeader: {
                ...tableHeaderStylesInMobile,
            },
        },
    },
    MUIDataTableBodyRow: {
        styleOverrides: {
            responsiveStacked: {
                borderTopWidth: '5px',
                borderBottomWidth: '5px',
            },
        },
    },
};

// Some of the MUI Data Table components have no component style overrides defined,
//  so I have to target them with CSS directly.
export const AxleTableGlobalStyles = () => (
    <GlobalStyles
        styles={{
            '[class*="MUIDataTableToolbar-filterPaper"]': {
                width: '400px',
                maxWidth: '80% !important',
            },
            '[class*="MUIDataTableFilter-gridListTile"]': {
                flexBasis: '100% !important',
                maxWidth: '100% !important',
            },
            // Overwrite the default styles for the toolbar select title
            '[class*="MuiTypography-root"][class*="MuiTypography-subtitle1"][class*="MUIDataTableToolbarSelect-title"]':
                {
                    // Your custom styles here
                    fontSize: 16,
                    fontWeight: 400,
                },
        }}
    />
);
